import { render } from "./PopularNewsCard.vue?vue&type=template&id=7be9476f"
import script from "./PopularNewsCard.vue?vue&type=script&lang=js"
export * from "./PopularNewsCard.vue?vue&type=script&lang=js"

import "./PopularNewsCard.vue?vue&type=style&index=0&id=7be9476f&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__